var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVolumeNone = function SvgVolumeNone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m18.775 11.183-1.208-1.208 1.166-1.167a.63.63 0 0 0 0-.883.63.63 0 0 0-.883 0l-1.167 1.167-1.208-1.209a.63.63 0 0 0-.883 0 .63.63 0 0 0 0 .884L15.8 9.975l-1.242 1.242a.63.63 0 0 0 0 .883.62.62 0 0 0 .442.183.62.62 0 0 0 .442-.183l1.241-1.242 1.209 1.209a.62.62 0 0 0 .441.183.62.62 0 0 0 .442-.183.63.63 0 0 0 0-.884M11.683 3.15c-.933-.517-2.125-.383-3.341.375L5.908 5.05a1.1 1.1 0 0 1-.55.158H4.167c-2.017 0-3.125 1.109-3.125 3.125v3.334c0 2.016 1.108 3.125 3.125 3.125h1.191c.192 0 .384.058.55.158l2.434 1.525c.733.458 1.45.683 2.116.683.434 0 .85-.1 1.225-.308.925-.517 1.442-1.592 1.442-3.025v-7.65c0-1.433-.517-2.508-1.442-3.025"
  })));
};
export default SvgVolumeNone;